<!-- eslint-disable vue/no-v-html -->
<template>
  <section class="py-12">
    <div class="container-wrap">
      <p v-if="contextData.sectionName" class="text-sm font-bold text-gray-600">
        {{ contextData.sectionName }}
      </p>
      <h2 class="text-h2 mb-6">{{ contextData.title }}</h2>
      <ul class="w-full" :class="contextItemsClass">
        <li v-for="item in contextItems" :key="item.name" class="mb-5">
          <div class="flex tablet:block">
            <TheProductIcon
              class="h-14 w-14 tablet:h-20 tablet:w-20"
              :src="item.thumbnail"
              :alt="item.name"
              :has-border="false"
              :has-shadow="false"
            />
            <div class="grow basis-0 pl-3 tablet:py-3 tablet:pl-0">
              <h3 class="text-h4 mb-1">{{ item.name }}</h3>
              <p
                class="text-sm text-gray-600 tablet:text-base"
                v-html="provideSanitized(decode(item.description))"
              />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
  import { decode } from 'entities';

  import type { ISuiteProps } from '@/components/Shared/Suite/type.ts';

  interface IItem {
    name: string;
    description: string;
    thumbnail: string;
  }

  interface ITechnologyData {
    sectionName?: string;
    title: string;
    numberOfLine: 2 | 3 | 4;
    items: IItem[];
  }

  interface ITechnology {
    component: 'topics-technology';
    meta: {
      navigable?: string;
    };
    data: ITechnologyData;
  }

  type IProps = ISuiteProps<ITechnology>;

  const props = defineProps<IProps>();

  const contextData = computed((): ITechnologyData => props.suiteData.data);

  const contextItems = computed((): IItem[] => contextData.value.items);

  const contextItemsClass = computed((): string => {
    switch (contextData.value.numberOfLine) {
      case 4:
        return 'column-421';
      case 3:
        return 'column-321';
      case 2:
        return 'column-221';
      default:
        return 'column-321';
    }
  });

  export type { ITechnology, ITechnologyData };
</script>
